import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2ProviderPatientsByPatientIdTimeline: build.query<
      GetV2ProviderPatientsByPatientIdTimelineApiResponse,
      GetV2ProviderPatientsByPatientIdTimelineApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/patients/${queryArg.patientId}/timeline`,
        params: {
          lens: queryArg.lens,
          kinds: queryArg.kinds,
          since: queryArg.since,
          before: queryArg.before,
          limit: queryArg.limit,
          cursor: queryArg.cursor,
          doc_kinds: queryArg.docKinds,
          q: queryArg.q,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2ProviderPatientsByPatientIdTimelineApiResponse =
  /** status 200 OK */ TimelineResponse;
export type GetV2ProviderPatientsByPatientIdTimelineApiArg = {
  patientId: string;
  /** Filter envelopes by lens group. `all` shows everything; `clinical` includes encounters, clinical documents, medication events, and scored assessments; `operational` shows payment events + communications; `admin` shows non-clinical forms, consents, ROIs, etc. When filtering, encounter roots are pulled in alongside any passing child. */
  lens?: "all" | "clinical" | "operational" | "admin";
  /** Restrict to one or more primitive kinds (document, encounter, payment_event, communication, form, medication_event). Repeat for OR semantics. Omit for all. */
  kinds?: string[] | null;
  /** Lower bound on envelope.effective_date (ISO-8601). */
  since?: string | null;
  /** Upper bound on envelope.effective_date (ISO-8601). */
  before?: string | null;
  /** Max root envelopes per page. Children travel with their root. */
  limit?: number;
  /** Opaque pagination cursor from a prior response's `next_cursor`. When set, takes precedence over `before`. */
  cursor?: string | null;
  /** Filter document envelopes by clinical doc_kind (clinical_note, lab_report, imaging, intake_form, consent, roi, insurance_card, referral, prior_records_packet, legal_document, discharge_summary, neuropsych_eval, assessment, markdown_doc, form, other). Repeat for OR semantics. Document adapter only — other primitives ignore. */
  docKinds?: string[] | null;
  /** Full-text search across document title + description. Accepts Postgres websearch_to_tsquery syntax (phrase quoting, boolean operators). Document adapter only — other primitives (encounter, payment, comm, form, med) ignore. */
  q?: string | null;
};
export type TimelineEnvelope = {
  effective_date: string;
  encounter_id?: string | null;
  extracted_at?: string | null;
  extracted_by?: string | null;
  group: "clinical" | "operational" | "admin";
  id: string;
  is_thread_root?: boolean;
  kind:
    | "document"
    | "encounter"
    | "payment_event"
    | "communication"
    | "form"
    | "medication_event";
  organization_id: string;
  patient_id: string;
  payload?: {
    [key: string]: any;
  };
  scope?: "patient";
  subkind?: string | null;
};
export type TimelineResponse = {
  items?: TimelineEnvelope[];
  next_cursor?: string | null;
  patient_id: string;
  threads?: {
    [key: string]: TimelineEnvelope[];
  };
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
